module.exports = __webpack_public_path__ + "img/channel-tw.74e6f4ad.png";